const SAGA_LINKS = {
    SAGA_HOMEPAGE_URL: 'https://www.saga.co.uk/',
    SAGA_INSURANCE_URL: 'https://www.saga.co.uk/insurance',
    MYSAGA_URL: 'https://www.saga.co.uk/mysaga/Default.aspx',
    CONTACT_US: 'https://www.saga.co.uk/contact-us',
    TERMS_AND_CONDITIONS: 'https://www.saga.co.uk/terms-and-conditions',
    COOKIES_POLICY: 'https://corporate.saga.co.uk/privacy-and-cookies',
    PRIVACY_POLICY: 'https://www.saga.co.uk/privacy-policy',
    BEREAVEMENT_SERVICE: 'https://www.saga.co.uk/insurance/saga-insurance-bereavement-service',
    INS_SUPPORT_SERVICE: 'https://www.saga.co.uk/insurance/saga-insurance-support-services',
    FRAUD_PREVENTING: 'https://www.saga.co.uk/car-insurance/preventing-fraud',
    ABI_CALCULATOR_LINK: 'https://abi.bcis.co.uk/calculator/calculator.aspx',

    MOTOR_GET_QUOTE: 'https://www.saga.co.uk/insurance/car-insurance/get-quote/',
    MOTORHOME_GET_QUOTE: 'https://www.saga.co.uk/insurance/motorhome-insurance/get-quote/',
    HOME_GET_QUOTE: 'https://www.saga.co.uk/insurance/home-insurance/get-quote/',
    TRAVEL_GET_QUOTE: 'https://www.saga.co.uk/insurance/travel-insurance/get-quote/',
    PMI_GET_QUOTE: 'https://www.saga.co.uk/insurance/health-insurance/get-quote/',
    MOTOR_INSURANCE_INFO: 'https://www.saga.co.uk/insurance/car-insurance',
    MOTORHOME_INSURANCE_INFO: 'https://www.saga.co.uk/insurance/motorhome-insurance',
    HOME_INSURANCE_INFO: 'https://www.saga.co.uk/insurance/home-insurance',
    TRAVEL_INSURANCE_INFO: 'https://www.saga.co.uk/insurance/travel-insurance',
    PMI_INSURANCE_INFO: 'https://www.saga.co.uk/insurance/health-insurance'
};

const STATUS = {
    BOUND: 'Bound'
};

const SG_ERROR_CODES = {
    SAGA_DECLINE: 0, // t=0,  Any Decline
    SAGA_REFERRAL: 1, // t=1,  Any Referral
    SAGA_SESSION_TIMEOUT: 2, // t=2,  Session Timed Out (no c=N required)
    SAGA_UPDATING_WEBSITE: 3, // t=3,  Site Taken Offline  (no c=N required)
    SAGA_WEBSITE_ERROR: 4, // t=4,  Generic Exceptions  (no c=N required)
    SAGA_QUOTATION_ERROR: 6, // t=6,  Pricing Exceptions   no c=N required)
    SAGA_QUOTATION_BIND_ERROR: 7, // t=7,  Pricing Exceptions  (no c=N required)
    BARCLAYCARD_FRAUDULENT_CARD: 8, // t=8   Barclaycard Fraudulent card
    SAGA_NON_PURCHASABLE_QUOTE: 9, // t=9,  Policy for these details already exists
    SAGA_PAYMENT_FAILED: 10, // t=10, Payment Failure  (no c=N required)
    SAGA_PAYMENT_NO_PAYMENT: 11, // t=11, Payment Failure no card details (no c=N required)
    SAGA_POLARIS_REFERRAL: 12, // t=12, All Panel Insurers refer (from Archimedes)
    SAGA_RETRIEVING_AMENDED_OFFLINE: 13, // t=13, Retrieval exceptions
    SAGA_CANNOT_RETRIEVE_ONLINE: 1234, // t=13, Retrieval exceptions
    SAGA_PC_CONNECTION_ERROR: 14, // t=14, PC Connection, typically HTTP Error 500 or 413
    SAGA_RETRIEVING_INVALID_COVER: 15, // t=15, Retrieval exceptions
    SAGA_BARCLAYCARD_REVIEW_RETRY: 16, // t=16, BarclayCard try again
    SAGA_RETRIEVE_TIA_QUOTE: 17, // t=17, Retrieve quote using TIA number
    SAGA_OFFLINE_EDIT_DURING_SESSION: 18, // t=18, Policy was changed offline during online session (de-504)
    SAGA_CEP_TIMEOUT_EXCEPTION: 18, // t=18, Timeout Exception
    SAGA_VERISK_EXCEPTION: 19, // t=19, Verisk Exception
    // Other SAGA errors
    SAGA_WRONG_URL_ERROR: 404,
    GW_ENTITY_NOT_FOUND_ERROR: 603,
    SAGA_SESSION_BLOCKED_ERROR: 800,
    SAGA_EXPIRED_QUOTE_RETRIEVAL_ERROR: 801
};

const SG_ERROR_REASONS = {
    PRICING_OR_ARCHIE_ERROR: 9124,
    ABILITY_TO_PAY_ERROR: 9199
};

const SAGA_PHONE_NUMBERS = {
    SAGA_ERROR_HOME_PHONE_NUMBER: '0800 302 9855',
    SAGA_ERROR_MOTOR_PHONE_NUMBER: '0800 092 1285',
    SAGA_ERROR_PAYMENT_HOME_PHONE_NUMBER: '0800 056 9102',
    SAGA_ERROR_PAYMENT_MOTOR_PHONE_NUMBER: '0800 414 413',
    SAGA_ERROR_PAYMENT_COMMON_PHONE_NUMBER: '0800 068 1889',
    SAGA_HELP_DESK_MOTOR_PHONE_NUMBER1: '0800 092 1220',
    SAGA_HELP_DESK_MOTOR_PHONE_NUMBER2: '0330 094 6166',
    SAGA_HELP_DESK_HOME_PHONE_NUMBER: '0330 094 6045',
    SAGA_HELP_DESK_CEP_PHONE_NUMBER: '0800 0152 833',
    SAGA_HELP_DESK_TRAVEL_PHONE_NUMBER: '0330 094 6244',
    SAGA_HELP_DESK_CEP_HOME_MTA_NOT_AVAILABLE_PHONE_NUMBER: '0800 3029 836',
    SAGA_HELP_DESK_COMMON_DEFAULT_PHONE_NUMBER: '0800 068 8718',
    SAGA_HELP_DESK_COMMON_PREMIUM_PHONE_NUMBER: '0800 092 1251',
    SAGA_HELP_DESK_MOTOR_CUE_PHONE_NUMBER: '0800 096 4078',
    SAGA_HELP_DESK_MOTOR_DECLARATIONS_PHONE_NUMBER: '0800 068 4494',
    SAGA_HELP_DESK_MOTOR_RETRIEVE_PHONE_NUMBER: '0808 101 5151',
    SAGA_HELP_DESK_MOTOR_CONFIRMATION_PHONE_NUMBER: '0800 092 5220',
    SAGA_HELP_DESK_COMMUNICATION_PREFERENCES_PHONE_NUMBER: '0800 015 0521',
    SAGA_HELP_DESK_GDPR_PHONE_NUMBER: '0800 092 3665',
    SAGA_SMI_HELP_DESK_GDPR_PHONE_NUMBER: '0330 018 1587',
    SAGA_MOTOR_AGGREGATOR_PHONE_NUMBER: '0800 096 5688',
    SAGA_MOTOR_CLAIMS_ASSISTANCE_PHONE_NUMBER: '0800 001 5424',
    SAGA_MOTOR_CLAIMS_GLASS_PHONE_NUMBER: '0800 092 3304',
    SAGA_MOTOR_CLAIMS_STANDARD_PHONE_NUMBER: '0800 096 3603',
    SAGA_MOTOR_ERROR_PAGE_PHONE_NUMBER: '0800 092 1414',
    SAGA_MOTOR_ERROR_PAGE_PHONE_NUMBER_FOR_DUP_POLICY_RENEWAL: '0800 056 9169',
    SAGA_MOTOR_ERROR_PAGE_PHONE_NUMBER_FOR_DUP_POLICY_CHANGE: '0800 056 9173',
    SAGA_HOME_ERROR_THREE_PROPERTIES_PHONE_NUMBER: '0800 015 1863',
    SAGA_HOME_ERROR_PAGE_PHONE_NUMBER1: '0800 056 9102',
    SAGA_HOME_ERROR_PAGE_PHONE_NUMBER2: '0800 001 5893',
    SAGA_HOME_TAILORMADE_PHONE_NUMBER: '0800 096 7622',
    SAGA_HOME_LANDLORD_PHONE_NUMBER: '0800 074 8027',
    SAGA_HOME_ASSUMPTIONS_PHONE_NUMBER: '0330 094 6611',
    SAGA_HOME_YOUR_CREDIT_EXPLAINED_PHONE_NUMBER: '0800 001 5898',
    SAGA_SMI_CONTACT_US_NUMBER: '0800 056 9273',
    SAGA_SMI_PHONE_NUMBER: '0330 094 6361',
    SAGA_SMI_CUSTOMER_SERVICES_NUMBER: '0330 018 1361',
    SAGA_SMI_CLAIMS_NUMBER: '0330 018 0778',
    SAGA_TRAVEL_PHONE_NUMBER: '0800 015 8055',
    SAGA_CEP_PAYMENT_PHONE_NUMBER: '0800 092 0125',
    SAGA_CEP_RENEWAL_COVER_LEVELS_PHONE_NUMBER: '0800 092 3295',
    SAGA_CEP_MOTOR_CHEQUE_PHONE_NUMBER: '0800 015 2833',
    SAGA_CEP_VEHICLE_ALTERNATIVE_ADDRESS_PHONE_NUMBER: '0800 092 3908',
    SAGA_CEP_HOME_CHEQUE_PHONE_NUMBER: '0800 302 9836',
    SAGA_CEP_MOVE_HOUSE_PHONE_NUMBER: '0800 056 9060',
    SAGA_IPID_HOME_PHONE_NUMBER1: '0800 001 5898',
    SAGA_IPID_HOME_PHONE_NUMBER2: '0800 904 7509',
    SAGA_IPID_MOTORHOME_PHONE_NUMBER: '0800 904 7763',
    SAGA_IPID_MOTOR_PHONE_NUMBER: '0800 092 9370',
    SAGA_IPID_OTHER_PHONE_NUMBER: '0800 056 9167',
    SAGA_CAIS_COMMON_PHONE_NUMBER: '0344 481 0800',
    SAGA_CEP_FAQ_MOTOR_PHONE_NUMBER1: '0800 302 9735',
    SAGA_CEP_FAQ_MOTOR_PHONE_NUMBER2: '0800 092 3195',
    SAGA_CEP_FAQ_HOME_PHONE_NUMBER1: '0800 096 3251',
    SAGA_CEP_FAQ_PMI_PHONE_NUMBER1: '0330 018 1587',
    SAGA_CEP_HOW_TO_CLAIM_PMI_NUMBER1: '0330 018 0779'
};

const ACTIVE_MVT_TESTS = {
    WOC_1169: 'WOC1169MTACoverCalculator',
    WOC_1680: 'WOC1680MotorAddingRetrievalLink',
    WOC_1837: 'WOC1837RenewalCoverAddOnsPage',
    WOC_2260: 'WOC2260HomeReorderingPages',
    WOC_2419: 'WOC2419HomeAggLogosQuotePage',
    WOC_2959: 'WOC2959MotorNewEnhanceYourCoverPage',
    WOC_2972: 'WOC2972MotorExpandableLabels',
    WOC_3143: 'WOC3143ReformatRenewalSummary',
    WOC_3222: 'WOC3222MotorDefactoTable',
    WOC_4177: 'WOC4177RenewalCoverCalculator',
    WOC_5070: 'WOC5070MotorPriceBreakdown',
    WOC_5162: 'WOC5162HomeAccidentalDamageBanner',
    WOC_5379: 'WOC5379ReformatMTASummaryPage',
    WOC_6520: 'WOC6520TravelCancellationTripQuestion',
    WOC_6798: 'WOC6798PmiIntegrateFirstQuestion',
    WOC_6890: 'WOC6890PmiEmailDoubleEntry',
    WOC_6903: 'WOC6903HomeEmailDoubleEntry',
    WOC_7059: 'WOC7059TravelEmailDoubleEntry',
    WOC_7033: 'WOC7033MotorEmailDoubleEntry'
};

const MEMBERSHIP_ACTIVATION_LINK = {
    PROD: 'https://www.saga.co.uk/membership/activate?aid=',
    DEV: 'https://uat-cms-01.saga.co.uk/membership/activate?aid='
};

const IPID_PAGE = {
    Insured: 'insured',
    NotInsured: 'notInsured',
    Restrictions: 'restrictions',
    Covered: 'covered',
    Obligations: 'obligations',
};

const PAYMENT_PLANS = {
    ANNUAL: 'Annual',
    ANNUAL_UPFRONT: 'Annual - Upfront',
    MONTHLY: 'Monthly',
    MONTHLY_UPFRONT: 'Monthly - Upfront',
    QUARTERLY: 'Quarterly'
};

const PAYMENT_PLANS_ID = {
    ANNUAL_DD: 'SG_PaymentPlan:1001',
    MONTHLY_DD: 'SG_PaymentPlan:1002',
    QUARTERLY_DD: 'SG_PaymentPlan:1003',
    ANNUAL_UPFRONT: 'SG_PaymentPlan:1004',
    MONTHLY_UPFRONT: 'SG_PaymentPlan:1005',
    MONTHLY_DD_ONE_MONTH_FREE: 'SG_PaymentPlan:1007',
    MONTHLY_DD_TWO_MONTHS_FREE: 'SG_PaymentPlan:1008',
    MONTHLY_DD_THREE_MONTHS_FREE: 'SG_PaymentPlan:1009'
};

const MONTHLY_PAYMENT_PLANS_ID = [
    PAYMENT_PLANS_ID.MONTHLY_DD_ONE_MONTH_FREE,
    PAYMENT_PLANS_ID.MONTHLY_DD_TWO_MONTHS_FREE,
    PAYMENT_PLANS_ID.MONTHLY_DD_THREE_MONTHS_FREE,
    PAYMENT_PLANS_ID.MONTHLY_DD,
    PAYMENT_PLANS_ID.MONTHLY_UPFRONT
];

const PAYMENT_HOLIDAYS_PLANS = [
    PAYMENT_PLANS_ID.MONTHLY_DD_ONE_MONTH_FREE,
    PAYMENT_PLANS_ID.MONTHLY_DD_TWO_MONTHS_FREE,
    PAYMENT_PLANS_ID.MONTHLY_DD_THREE_MONTHS_FREE
];

const PAYMENT_UI_MIXED_VIEW = { // Level 2 view - DDI/Card
    CARD_DETAILS: 'cardDetails',
    DDI_DETAILS: 'ddiDetails'
};

const SAGA_OUTSIDE_CEP_PATHS = [
    'https://www.saga.co.uk',
    'https://www.gov.uk',
    'tel:',
    'https://www.moneyhelper.org.uk',
    'https://www.bupa.co.uk'
];

const SAGA_ARTICLES_URLS = {
    REDUCE_ENERGY_BILLS: 'https://www.saga.co.uk/home-insurance/how-to-reduce-energy-bills',
    WORKING_FROM_HOME: 'https://www.saga.co.uk/home-insurance/working-from-home-insurance',
    GARAGE_INSURANCE: 'https://www.saga.co.uk/home-insurance/garage-insurance',
    NEW_BOILER_COST: 'https://www.saga.co.uk/home-insurance/new-boiler-cost',
    ENGAGEMENT_RING_INSURANCE: 'https://www.saga.co.uk/home-insurance/engagement-ring-insurance',
    CAR_BREAK_DOWN: 'https://www.saga.co.uk/car-insurance/what-to-do-if-you-break-down',
    KEYLESS_CAR_THEFT: 'https://www.saga.co.uk/car-insurance/car-keyless-theft',
    CHILD_CAR_SEAT: 'https://www.saga.co.uk/car-insurance/child-car-seat-laws',
    DRIVING_ABROAD: 'https://www.saga.co.uk/car-insurance/driving-abroad',
    PENALTY_POINTS: 'https://www.saga.co.uk/car-insurance/do-penalty-points-affect-insurance',
    HOLIDAY_CHECKLIST: 'https://www.saga.co.uk/travel-insurance/holiday-checklist',
    CANCELLED_FLIGHTS: 'https://www.saga.co.uk/travel-insurance/does-travel-insurance-cover-cancelled-flights',
    TRAVEL_GP: 'https://www.saga.co.uk/travel-insurance/travel-gp-service',
    TRAVEL_PROTECT: 'https://www.saga.co.uk/travel-insurance/keep-valuables-safe-on-holiday',
    DELAYED_FLIGHT: 'https://www.saga.co.uk/travel-insurance/delayed-flight-assistance',
    HOW_TO_MAKE_CLAIM: 'https://www.saga.co.uk/car-insurance/how-to-make-a-claim',
    CAR_FOR_WOMEN: 'https://www.saga.co.uk/car-insurance/car-insurance-for-women',
    CAR_BOOKING_SERVICE: 'https://www.saga.co.uk/car-insurance/booking-a-car-service',
    CARS_FOR_OLDER_DRIVERS: 'https://www.saga.co.uk/car-insurance/cars-for-over-50s-drivers',
    CAR_DRIVING_OTHER_CARS: 'https://www.saga.co.uk/car-insurance/driving-other-cars',
    BOILER_SERVICE: 'https://www.saga.co.uk/home-insurance/boiler-service-tips',
    HOME_FIRE: 'https://www.saga.co.uk/home-insurance/home-fire-insurance',
    HOME_SURVEILLANCE: 'https://www.saga.co.uk/home-insurance/home-security-and-surveillance',
    HOME_SHED: 'https://www.saga.co.uk/home-insurance/shed-insurance',
    CAR_BAN: 'https://www.saga.co.uk/car-insurance/2035-car-ban',
    CAR_MED_COND: 'https://saga.co.uk/car-insurance/driving-with-a-medical-condition',
    CAR_MOT: 'https://www.saga.co.uk/car-insurance/mot-tips',
    CAR_ELECTRIC_ROAD: 'https://www.saga.co.uk/car-insurance/electric-road-trips',
    CAR_EXCESS: 'https://www.saga.co.uk/car-insurance/car-insurance-excess',
    SELF_EMPLOYED: 'https://www.saga.co.uk/health-insurance/self-employed-health-insurance',
    PRE_EXISTING_CONDITIONS: 'https://www.saga.co.uk/health-insurance/health-insurance-pre-existing-conditions',
    BOOST_YOUR_IMMUNE_SYSTEM: 'https://www.saga.co.uk/health-insurance/boost-your-immune-system',
    OPTIONS_TO_IMPROVE_COVER: 'https://www.saga.co.uk/health-insurance/options-to-improve-your-cover',
    YOUR_CHOICE_OF_HOSPITAL: 'https://www.saga.co.uk/health-insurance/your-choice-of-hospital'
};

const COMM_PREFERENCE_ERROR_MODAL = {
    TITLE: 'Unable to update preferences',
    // eslint-disable-next-line max-len
    MESSAGE: 'Unfortunately something has gone wrong and we have been unable to store your marketing preferences. You can manage your preferences at any time by calling us on',
    TRAVEL_PHONE: '0800 015 8055',
    OK: 'Ok'
};

const CVC_UPDATE_ERROR_MODAL = {
    TITLE: 'Sorry, we haven\'t been able to save your document preference',
    // eslint-disable-next-line max-len
    MESSAGE: 'You\'ll get your documents in the correct format this time, but to make sure you get them like this in the future, please complete our support services form. There\'s a link to it on the page when you close this pop-up. ',
    OK: 'Ok'
};

const DDA_FORMAT_CODE = {
    NONE: 'None'
};

const SAGA_PRIVACY_LINK = 'https://www.saga.co.uk/Privacy-Policy.aspx';
const SAGA_CONTACT_PREF_LINK = 'https://www.saga.co.uk/my/account/contact-preferences';
const MY_SAGA_LINK = 'https://www.saga.co.uk/my/account';
const SAGA_FRAUD_PREVENTION_LINK = 'https://www.saga.co.uk/car-insurance/preventing-fraud';
const SAGA_TERMS_LINK = 'https://www.saga.co.uk/terms-and-conditions';
const FCA_NEW_REGISTER_LINK = 'https://register.fca.org.uk/';
const SAGA_CLAIMS_LINK = 'https://saga.claimhere.co.uk/support/home';
const DISCLOSURE_CALCULATOR_LINK = 'https://unlock.org.uk/disclosure-calculator/';

const CUSTOMER_PERMISSION_SECTION = {
    CONTACT_PREFERENCES: 'contact preferences',
    MY_SAGA: 'MySaga',
    LIVE_CHAT: 'Live chat',
    PRIVACY_POLICY: 'privacy policy',
    PRIVACY_POLICIES: 'privacy policies',
    AGEAS: 'Ageas',
    SAGA_GROUP: 'Saga Group',
    SAGA_PARTNER: 'Saga partner content',
    LET_ME_CHOOSE: 'Custom',
    YES_PLEASE: 'Yes',
    NO_THANKS: 'No',
    INSURANCE_NAME: 'Saga Insurance (Including Ageas)',
    OPTED_IN: 1,
    OPTED_OUT: 2,
    CHANNEL: 5,
    INSURANCE_ID: 8,
    SAGA_GROUP_ID: 1,
    WORDING_ID: '1',
    WORDING_ID_AGEAS: '2',
    MOTOR_JOURNEY: 'WE004MTQ05',
    MOTOR_AGG_JOURNEY: 'WE004MTA05',
    MOTOR_AGEAS_AGG_JOURNEY: 'WE004MTA06',
    MOTOR_AGEAS_JOURNEY: 'WE004MTQ06',
    HOME_JOURNEY: 'WE004HHQ05',
    HOME_AGG_JOURNEY: 'WE004HHA05',
    HOME_AGEAS_AGG_JOURNEY: 'WE004HHA06',
    HOME_AGEAS_JOURNEY: 'WE004HHQ06',
    HOME_PRODUCT: 'Home',
    MOTOR_PRODUCT: 'Motor',
    SOURCE: {
        HOME_JOURNEY: 'INSHOMWEB',
        MOTOR_JOURNEY: 'INSMOTWEB',
        HOME_AGGREGATOR: 'INSHOMAGG',
        MOTOR_AGGREGATOR: 'INSMOTAGG',
        TRAVEL_JOURNEY: 'INSTRAWEB',
        TRAVEL_AGGREGAROR: 'INSTRAAGG',
        PMI_JOURNEY: 'INSPMIWEB',
        GENERAL: 'WEB'
    }
};

const POLICY_PERIOD_STATUS = {
    QUOTED: 'Quoted',
    BOUND: 'Bound',
};

const COVER_LEVEL_NAMES = {
    PLUS: 'Saga Plus',
    SELECT: 'Saga Select',
    STANDARD: 'Saga Standard',
    ESSENTIAL: 'Saga Essential'
};

const HOME_COVER_TYPES = {
    BUILDINGS_AND_CONTENTS: 'Buildings and Contents',
    BUILDINGS_ONLY: 'Buildings Only',
    CONTENTS_ONLY: 'Contents Only'
};

const CANCELLATION_FEES = {
    PrivateMotor: 50,
    PrivateHome: 35
};

const JOB_TYPES = {
    RENEWAL: 'Renewal',
    POLICY_CHANGE: 'PolicyChange'
};

const PAYMENT_METHOD_CODES = {
    CREDIT_CARD: 'creditcard',
    DIRECT_DEBIT: 'directdebit_Ext',
    CHEQUE: 'cheque_ext',
    REDISTRIBUTE: 'redistribute',
    NO_PAYMENT_REQUIRED_PAYMENT_METHOD: 'none',
    MIXED: 'mixed',
    DDI: 'ddi'
};

const PAYMENT_FREQUENCY = {
    MONTHLY: 'monthly',
    ANNUAL: 'annual',
    QUARTERLY: 'quarterly'
};

const PAYMENT_RESPONSES = {
    SUCCESS: 'SUCCESS',
    REVIEW_AND_RETRY: 'REVIEW_AND_RETRY',
    ALTERNATIVE_CARD: 'ALTERNATIVE_CARD',
    FRAUDULENT_CARD: 'FRAUDULENT_CARD'
};

const CUSTOM_EVENTS = {
    QUOTING_PROCESS: 'CUSTOM_EVENTS.QUOTING_PROCESS'
};

const EVENT_KEYS = {
    ENTER_KEY: 'Enter',
    SPACEBAR_CODE: 32,
    TAB_KEY: 'Tab',
    ARROW_UP_KEY: 'ArrowUp',
    ARROW_DOWN_KEY: 'ArrowDown',
    ARROW_DOWN_KEY_CODE: 40,
    ESCAPE_KEY: 'Escape',
    LETTERS_AND_NUMBERS_RANGE_START: 48,
    LETTERS_AND_NUMBERS_RANGE_END: 105
};

const GDPR_RECONSENT_SECTION = {
    MAGAZINE: 'Magazine',
    INSURANCE: 'Insurance',
    FINANCE: 'Finance',
    TRAVEL: 'Travel',
    HOLIDAY_AND_CRUISES: 'Holidays and Cruises',
    PERSONAL_FINANCE: 'Personal Finance',
    SAGA_MAGAZINE: 'Saga Magazine',
    EMAIL: 'email',
    LETTER: 'letter',
    PHONE: 'phone',
    OPT_OUT: 'optOut'
};

const BUSINESS_TYPES = {
    UNKNOWN: 'Unknown'
};

const QUOTATION_TYPE = {
    INDICATIVE_QUOTE: 'IndicativeQuote',
    INDICATIVE_TO_FULL_QUOTE: 'IndicativeToFullQuote'
};

const QUICK_QUOTE_CAMPAIGN_CODE = 'ONLQQ1';

const RESPONSE = {
    SUCCESS: 'SUCCESS'
};

const SAGA_PRODUCTS_LINKS = {
    CAR: 'https://www.saga.co.uk/insurance/campaign/car-insurance',
    HOME: 'https://www.saga.co.uk/insurance/campaign/home-insurance',
    HEALTH: 'https://www.saga.co.uk/insurance/campaign/health-insurance',
    TRAVEL: 'https://www.saga.co.uk/insurance/campaign/travel-insurance',
    SAVINGS: 'https://www.saga.co.uk/money/savings'
};

const AGGREGATOR_PRODUCT_CODES = {
    MOTOR: 'motor',
    HOME: 'home',
    PMI: 'smi',
    TRAVEL: 'travel'
};

const REGEX_CONSTANTS = {
    DASH_SIGN: '-',
    EMPTY_VALUE: '',
    NON_NUMBERS: /\D+/g,
    TWO_ELEMENT_DIVISION: /.{1,2}/g
};
const AF_INCREASE_EFFECTIVE_DATE = '2023-10-06';

export default {
    SAGA_LINKS,
    STATUS,
    AGGREGATOR_PRODUCT_CODES,
    SHOW_VALIDATION_ERROR_EVENT: 'sg:validation:show',
    HIDE_VALIDATION_ERROR_EVENT: 'sg:validation:hide',
    ACCORDION_VALIDATION_ERROR_EVENT: 'sg:accordion-validation:show',
    GDPR_SERVICE_CALLED_EVENT: 'sg:gdpr:service:called',
    SHOW_CPA_EVENT: 'sg:cpa:show',
    OPEN_NEXT_ACCORDION_EVENT: 'sg:accordion:open',
    UNLISTED_INSURER_CODE: '999',
    TITLE_MR: 'mr',
    TITLE_DR: 'dr',
    GENDER_MALE: 'M',
    GENDER_FEMALE: 'F',
    TITLE: 'title',
    GENDER: 'gender',
    SG_ERROR_CODES,
    SG_ERROR_REASONS,
    SAGA_PRIVACY_LINK,
    SAGA_PHONE_NUMBERS,
    SAGA_ARTICLES_URLS,
    ACTIVE_MVT_TESTS,
    BIND_AVAILABLE_DAYS_IN_ADVANCE: 30,
    HOME_PRODUCT_CODE: 'PrivateHome',
    HOME_PRODUCT_DISPLAY: 'Home',
    MOTOR_PRODUCT_CODE: 'PrivateMotor',
    MOTOR_PRODUCT_DISPLAY: 'Car',
    TRAVEL_PRODUCT_DISPLAY: 'Travel',
    MOTORHOME_PRODUCT_DISPLAY: 'Motorhome',
    PRIVATE_MEDICAL_INSURANCE_CODE: 'PrivateMedical',
    TRAVEL_PRODUCT_CODE: 'PrivateTravel',
    TRAVEL_PRODUCT_CODE_SPT: 'spt',
    MOTORHOME_PRODUCT_CODE: 'mh',
    PMI_PRODUCT_CODE: 'pmi',
    SAGA_PRODUCTS_LINKS,
    MEMBERSHIP_ACTIVATION_LINK,
    TRUSTPILOT_LINK: 'https://www.trustpilot.com/evaluate-bgl/saga.co.uk?p=',
    QUICK_QUOTE_MOTOR_PARAM: '&product=PrivateMotor',
    QUICK_QUOTE_HOME_PARAM: '&product=PrivateHome',
    SAGA_HOME: 'https://www.saga.co.uk',
    EMPLOYMENT_STATUS_EMPLOYED: 'employed',
    EMPLOYMENT_STATUS_SELF_EMPLOYED: 'Self_Employed',
    EMPLOYMENT_STATUS_RETIRED: 'retired',
    EMPLOYMENT_STATUS_OTHER: 'Other',
    IPID_PAGE,
    PAYMENT_PLANS,
    PAYMENT_PLANS_ID,
    PAYMENT_HOLIDAYS_PLANS,
    MONTHLY_PAYMENT_PLANS_ID,
    SAGA_OUTSIDE_CEP_PATHS,
    POLICY_PERIOD_STATUS,
    COVER_LEVEL_NAMES,
    HOME_COVER_TYPES,
    JOB_TYPES,
    CANCELLATION_FEES,
    PAYMENT_METHOD_CODES,
    PAYMENT_FREQUENCY,
    REGEX_CONSTANTS,
    CUSTOM_EVENTS,
    EVENT_KEYS,
    SAGA_TERMS_LINK,
    SAGA_FRAUD_PREVENTION_LINK,
    FCA_NEW_REGISTER_LINK,
    COMM_PREFERENCE_ERROR_MODAL,
    GDPR_RECONSENT_SECTION,
    CLOSE_NON_PERSISTENT_ACCORDION_EVENT: 'sg:accordion:non:persistent:close',
    BUSINESS_TYPES,
    QUOTATION_TYPE,
    PAYMENT_UI_MIXED_VIEW,
    PAYMENT_RESPONSES,
    QUICK_QUOTE_CAMPAIGN_CODE,
    SAGA_CLAIMS_LINK,
    CVC_UPDATE_ERROR_MODAL,
    DDA_FORMAT_CODE,
    RESPONSE,
    AF_INCREASE_EFFECTIVE_DATE,
    CUSTOMER_PERMISSION_SECTION,
    SAGA_CONTACT_PREF_LINK,
    MY_SAGA_LINK,
    DISCLOSURE_CALCULATOR_LINK,
    PRODUCT_NO_LONGER_RETRIEVABLE: 'Permission to retrieve unavailable product',
    SAGA_PRODUCTION_HOST_NAME: 'www.saga.co.uk'
};
